// extracted by mini-css-extract-plugin
var _1 = "lnTBX";
export { _1 as "loading" }
